export default {
	create (params = new URLSearchParams()) {
		return Axios.post(API_BASE + 'staff_todo/create', params)
	},
	update (params = new URLSearchParams()) {
		return Axios.post(API_BASE + 'staff_todo/update', params)
	},
	delete (params = new URLSearchParams()) {
		return Axios.post(API_BASE + 'staff_todo/delete', params)
	},
	all (params = new URLSearchParams()) {
		return Axios.post(API_BASE + 'staff_todo/all', params)
	},
	one (params = new URLSearchParams()) {
		return Axios.post(API_BASE + 'staff_todo/one', params)
	},
	count_per_staff (params = new URLSearchParams()) {
		return Axios.post(API_BASE + 'staff_todo/count_per_staff', params)
	}
}



// WEBPACK FOOTER //
// ./src/api/StaffTodo.js